<template>
  <v-flex xs12 sm4>
    <v-layout row column ml-2>
    <v-toolbar
        color="success"
        dark
        dense
        flat
    >
      <v-toolbar-title>{{ 'app.pages.home.see' | trans }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-list :dense="true" :expand="true">
      <v-list-group
          v-for="item in lists"
          :key="item.title"
          :value="openGroup"
          append-icon=""
      >
        <template v-slot:activator>
          <v-list-tile>
            <icon-button
                :icon="item.icon"
                color="success"
                cls="mr-2 ml-0"
                id="test"
                medium
                :iconOptions="{medium: true}"
                :href="item.url"
                :tooltip='{top: true, bottom: false, attach: false}'
            >
              {{ 'app.pages.home.see_more' | trans  }}
            </icon-button>

            <v-list-tile-content class="group-title">
              <v-list-tile-title>
                {{ item.title | trans}}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <v-list-tile
            v-for="subItem in item.items"
            :key="subItem.id"
            @click="redirectItem(item.title, subItem.id)"
        >
          <v-list-tile-content>
            <v-list-tile-title>
              <icon-button
                  v-if="item.title === 'app.pages.home.patients'"
                  icon="event_note"
                  color="purple"
                  cls="mr-0 ml-0"
                  :iconOptions="{small: false}"
                  :href="`/patients/${subItem.id}/menu`"
                  :tooltip="{top: true, bottom: false, attach: false}"
              >
                {{ 'app.pages.home.menu' | trans  }}
              </icon-button>

              <icon-button
                  v-if="item.title === 'app.pages.home.patients'"
                  icon="signal_cellular_alt"
                  color="blue"
                  cls="mr-0 ml-0"
                  :iconOptions="{small: false}"
                  :href="`/patients/${subItem.id}/measurement`"
                  :tooltip="{top: true, bottom: false, attach: false}"
              >
                {{ 'app.pages.home.measurements' | trans  }}
              </icon-button>

              <icon-button
                  v-if="item.title === 'app.pages.home.patients'"
                  icon="assignment"
                  color="success"
                  cls="mr-0 ml-0"
                  :iconOptions="{small: false}"
                  :href="`/patients/${subItem.id}/interview`"
                  :tooltip="{top: true, bottom: false, attach: false}"
              >
                {{ 'app.pages.home.interview' | trans  }}
              </icon-button>

              {{ subItem.name }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
    </v-list>
  </v-layout>
  </v-flex>
</template>

<script>
export default {
  data: function () {
    return {
      lists: [],
      openGroup: true
    }
  },
  props: {
    latest_food: {
      type: String
    },
    latest_patients: {
      type: String
    }
  },
  mounted() {
    const latestFood = JSON.parse(this.latest_food).map(food => {
      return {id: food.id, name: food.name};
    });

    const latestPatients = JSON.parse(this.latest_patients).map(patient => {
      return {
        id: patient.id,
        name: `${patient.first_name} ${patient.last_name}`
      };
    });

    this.lists.push(...[
      {
        title: 'app.pages.home.meals',
        items: latestFood,
        icon: 'menu_book',
        url: '/foods/all/latest'
      },
      {
        title: 'app.pages.home.patients',
        items: latestPatients,
        icon: 'person',
        url: '/patients'
      }
    ]);
  },
  methods: {
    redirectItem(itemName, itemId) {
      switch (itemName) {
        case 'app.pages.home.meals':
          window.location.href = `/foods/all/${itemId}`;
          break;
        case 'app.pages.home.patients':
          window.location.href = `/patients/${itemId}/panel`;
          break;
      }
    },
  }
}
</script>

<style scoped>
.group-title{
  font-weight: 700;
  font-size:16px;
  text-transform: uppercase;
}
.v-list__tile__title{
  height:52px;
  line-height: 40px;
}
.v-list__tile__content{
  font-size:14px;
  font-family: 'Open Sans', sans-serif;
}

.v-list__tile{
  padding:0;
}
</style>
